import { PropsWithChildren } from 'react';

import { useAtomValue } from 'jotai';
import { ScopeProvider } from 'jotai-scope';

import { activeSwingIdAtom } from '../atoms/global/url';
import { activeAnalysisAtom, activeVideoAtom } from '../atoms/swing/swings';
import { swingThreadOpenAtom } from '../atoms/swing/swingThreads';

export const SwingScope = ({ children }: PropsWithChildren) => {
    const swingId = useAtomValue(activeSwingIdAtom);
    return (
        <ScopeProvider key={swingId} atoms={[activeAnalysisAtom, activeVideoAtom, swingThreadOpenAtom]}>
            {children}
        </ScopeProvider>
    );
};

export const withSwingScope = <C extends React.ComponentType<any>>(Component: C) => {
    type Props = React.ComponentProps<C>;

    const Wrapped = (props: Props) => (
        <SwingScope>
            <Component {...props} />
        </SwingScope>
    );

    Wrapped.displayName = `withSwingScope(${Component.displayName ?? Component.name ?? 'Component'})`;
    return Wrapped;
};
